module.exports = __webpack_public_path__ + "img/standard_bg.cccd1059.png";